import BindOrder from './src/main'

export default {
  install(Vue, props) {
    Vue.prototype.$BindOrder = options =>  BindOrder(options, props)
  }
}
